import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  Popup,
  Heading,
  I18n,
  Button,
  Preloader,
} from 'components';

import { formatDateString } from 'utils/formatString';

import SaveDetalization from '../SaveDetalization';

import { UI_DATE_FORMAT } from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class SaveDetalizationPopup extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      includeStructure: true,
      includeDetalization: true,
      sendToEmail: true,
      savingError: false,
      savingSuccess: false,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.isOpened && !props.isOpened) {
      this.setState({
        includeStructure: true,
        includeDetalization: true,
        sendToEmail: true,
        savingError: false,
        savingSuccess: false,
      });
    }

    if (props.isOpened && this.props.isSaving && !props.isSaving) {
      this.setState({
        savingError: !!props.savingError,
        savingSuccess: !props.savingError,
      });
    }
  }

  saveReport = () => {
    const {
      saveReport,
      invoiceNumber,
      endDate,
      isEmailConfirmed,
      benNumber,
      ctnFor,
    } = this.props;

    const {
      includeStructure,
      includeDetalization,
      sendToEmail,
    } = this.state;

    if (invoiceNumber) {
      saveReport({
        ben: benNumber,
        billDate: endDate,
        isSendToEmail: isEmailConfirmed && sendToEmail,
        includeCallDetail: includeDetalization,
        includeCharges: includeStructure,
      });
    } else {
      saveReport({
        ctnFor,
        isEmailSend: isEmailConfirmed && sendToEmail,
      });
    }
  };

  render() {
    const {
      isOpened,
      closePopup,
      invoiceNumber,
      startDate,
      endDate,
      isSaving,
      isEmailConfirmed,
      stopDownloading,
    } = this.props;

    const {
      includeStructure,
      includeDetalization,
      sendToEmail,
      savingError,
      savingSuccess,
    } = this.state;

    if (isSaving) {
      return (
        <Popup
          opened={isOpened}
          onClose={stopDownloading}
        >
          <Heading className={cx('title')} level={1}>
            <I18n path="detalization.postpaidInvoices.prepareReportTitle" />
          </Heading>
          <Heading className={cx('subtitle')} level={5}>
            <I18n path="detalization.postpaidInvoices.prepareReportSubtitle" />
          </Heading>
          <Preloader className={cx('preloader')} size="80" />
        </Popup>
      );
    }

    if (savingError) {
      return (
        <Popup
          opened={isOpened}
          onClose={closePopup}
        >
          <Heading level={1}>
            <I18n path="common.somethingWentWrong" />
          </Heading>
          <Button
            className="big"
            onClick={this.saveReport}
          >
            <I18n path="common.retry" />
          </Button>
        </Popup>
      );
    }

    if (savingSuccess) {
      return (
        <Popup
          opened={isOpened}
          onClose={closePopup}
        >
          <Heading level={1}>
            <I18n path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.successTitle" />
          </Heading>
          <Button
            className="big"
            onClick={closePopup}
          >
            <I18n path="common.continueWorking" />
          </Button>
        </Popup>
      );
    }

    return (
      <Popup
        opened={isOpened}
        onClose={closePopup}
      >
        <Heading className={cx('title')} level={1}>
          {invoiceNumber ? (
            <I18n
              path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.title"
              vars={{
                start: formatDateString(startDate, UI_DATE_FORMAT),
                end: formatDateString(endDate, UI_DATE_FORMAT),
                invoice: invoiceNumber,
              }}
            />
          ) : (
            <I18n
              path="detalization.postpaidInvoices.invoice.saveDetalizationPopup.ctnTitle"
              vars={{
                start: formatDateString(startDate, UI_DATE_FORMAT),
                end: formatDateString(endDate, UI_DATE_FORMAT),
              }}
            />
          )}
        </Heading>
        <SaveDetalization
          showSavingOptions={!!invoiceNumber}
          includeStructure={includeStructure}
          includeDetalization={includeDetalization}
          sendToEmail={sendToEmail}
          isEmailConfirmed={isEmailConfirmed}
          toggleIncludeStructure={() => this.setState({
            includeStructure: !includeStructure,
          })}
          toggleIncludeDetalization={() => this.setState({
            includeDetalization: !includeDetalization,
          })}
          toggleSendToEmail={() => this.setState({
            sendToEmail: !sendToEmail,
          })}
          saveReport={this.saveReport}
        />
      </Popup>
    );
  }
}

SaveDetalizationPopup.propTypes = {
  isOpened: PropTypes.bool,
  closePopup: PropTypes.func,
  stopDownloading: PropTypes.func,
  saveReport: PropTypes.func,
  invoiceNumber: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  isSaving: PropTypes.bool,
  savingError: PropTypes.string,
  isEmailConfirmed: PropTypes.bool,
  benNumber: PropTypes.number,
  ctnFor: PropTypes.string,
};

export default SaveDetalizationPopup;
